var _rect, _path, _rect2, _path2, _path3, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDoorSliding = function SvgDoorSliding(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 13.66,
    height: 23.82,
    x: 11.75,
    y: 4.09,
    fill: "red",
    stroke: "currentColor",
    strokeWidth: 2.67,
    rx: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 2.67,
    d: "M4.29 27.91H28.3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 13.93,
    height: 23.82,
    x: 5.95,
    y: 4.09,
    fill: "#fff",
    stroke: "currentColor",
    strokeWidth: 2.67,
    rx: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M23.87 6.7c-.37-.36-.96-.08-.96.47v1.85h-3.33a1 1 0 0 0-1 1v1.76a1 1 0 0 0 1 1h3.33v2.1c0 .54.6.82.96.46l3.42-3.4c.5-.5.5-1.34 0-1.84z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M22.9 12.78h-3.32a1 1 0 0 1-1-1v-1.76a1 1 0 0 1 1-1h3.33V7.17c0-.55.6-.83.96-.46l3.42 3.4c.5.49.5 1.34 0 1.83l-3.42 3.4c-.37.36-.96.08-.96-.46v-2.1Zm-1.5 1.5v.6c0 .85.5 1.58 1.2 1.92.74.35 1.67.26 2.33-.4l3.42-3.4a2.82 2.82 0 0 0 0-3.96l-3.42-3.4a2.03 2.03 0 0 0-2.32-.4 2.12 2.12 0 0 0-1.2 1.93v.35h-1.83a2.5 2.5 0 0 0-2.5 2.5v1.76a2.5 2.5 0 0 0 2.5 2.5h1.83Z",
    clipRule: "evenodd"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.06,
    cy: 16,
    r: 1.5
  })));
};
export default SvgDoorSliding;